import { useEffect, useState } from "react";
import { api, formatError } from "../../lib/api";
import { toast } from "sonner";
import { CertificationsAdmin } from "./CertificationsAdmin";
import { QuestionsAdmin } from "./QuestionsAdmin";
import { LearnersAdmin } from "./LearnersAdmin";
import { InsightsAdmin } from "./InsightsAdmin";
import { OverviewAdmin } from "./OverviewAdmin";
import { PartnersAdmin } from "./PartnersAdmin";
import { MessagesAdmin } from "./MessagesAdmin";
import { PaymentsDesk } from "./PaymentsDesk";
import { AccessLogRecords, CertificatesRecords, PaymentsRecords, ResultsRecords } from "./RecordsAdmin";

const TABS = [["overview", "Overview"], ["certifications", "Certifications"], ["questions", "Questions"], ["insights", "Insights"], ["learners", "Learners"], ["payments", "Payments"], ["results", "Results"], ["certificates", "Certificates"], ["partners", "Partners"], ["desk", "Payments Desk"], ["messages", "Messages"], ["access", "Access log"]];

const Stats = ({ stats }) => (
  <div className="admin-stats">{[[stats.learners, "Learners"], [stats.certifications, "Certifications"], [stats.attempts, "Assessment attempts"], [stats.paid_orders, "Paid orders"], [stats.certificates, "Certificates"]].map(([v, label]) => (
    <div className="admin-stat" data-testid={`admin-stat-${label.toLowerCase().replaceAll(" ", "-")}`} key={label}><strong>{v}</strong><span>{label}</span></div>))}
  </div>
);

export default function Admin({ user }) {
  const [tab, setTab] = useState("overview");
  const [stats, setStats] = useState(null);
  const [certs, setCerts] = useState([]);
  const refresh = () => {
    api.get("/admin/summary").then((r) => setStats(r.data)).catch((e) => toast.error(formatError(e)));
    api.get("/admin/certifications").then((r) => setCerts(r.data)).catch((e) => toast.error(formatError(e)));
  };
  useEffect(refresh, []);
  const views = {
    overview: <OverviewAdmin />,
    certifications: <CertificationsAdmin certs={certs} refresh={refresh} />,
    questions: <QuestionsAdmin certs={certs} refresh={refresh} />,
    insights: <InsightsAdmin certs={certs} />,
    learners: <LearnersAdmin me={user} />,
    payments: <PaymentsRecords mode={stats?.payments_mode} />, results: <ResultsRecords />, certificates: <CertificatesRecords />, access: <AccessLogRecords />, partners: <PartnersAdmin />, messages: <MessagesAdmin />, desk: <PaymentsDesk />,
  };
  return (
    <main className="page admin">
      <div className="page-intro"><div><div className="section-kicker">ADMIN CONSOLE</div><h1>Platform<br /><span>operations.</span></h1></div><p>Manage AVAILITY credentials, question banks, learners, payments, results, and issued certificates.</p></div>
      {stats && <Stats stats={stats} />}
      <div className="admin-tabs" role="tablist">{TABS.map(([key, label]) => (
        <button key={key} role="tab" aria-selected={tab === key} className={tab === key ? "admin-tab active" : "admin-tab"} data-testid={`admin-tab-${key}`} onClick={() => setTab(key)}>{label}</button>))}
      </div>
      <div className="admin-view" data-testid={`admin-view-${tab}`}>{views[tab]}</div>
    </main>
  );
}
